




































































































































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { mapActions } from "vuex";
import { Contrato } from "@/typings/store/plugins/easyFirestore/contratos";
import { CondicionComercial } from "@/typings/store/plugins/easyFirestore/condicionesComerciales";
import { CondicionDivision } from "@/typings/store/plugins/easyFirestore/condicionesDivisiones";
import { DataFormularioCondicionComercial } from "@/typings/components/condicionesComerciales/formulario";
import { DataFormularioCondicionDivision } from "@/typings/components/condicionesDivisiones/formulario";
import TablaCondicion from "@/components/condicionesComerciales/Tabla.vue";
import TablaDivision from "@/components/condicionesDivisiones/Tabla.vue";
import FormularioCondicion from "@/components/condicionesComerciales/Formulario.vue";
import FormularioDivision from "@/components/condicionesDivisiones/Formulario.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import ExcepcionesContrato from "@/components/contratos/Excepciones.vue";
import { aFecha } from "@/helpers/fechas";

type Pendiente =
  | { tipo: "condicion"; condicion: CondicionComercial; divisiones: CondicionDivision[] }
  | { tipo: "division"; division: CondicionDivision };

@Component({
  methods: mapActions({
    setCondicionComercial: "condicionesComerciales/set",
    deleteCondicionComercial: "condicionesComerciales/delete",
    setCondicionDivision: "condicionesDivisiones/set",
    deleteCondicionDivision: "condicionesDivisiones/delete",
  }),
  components: {
    TablaCondicion,
    TablaDivision,
    FormularioCondicion,
    FormularioDivision,
    DialogoEliminar,
    ExcepcionesContrato,
  },
})
export default class CondicionContrato extends Vue {
  @Prop() readonly contrato!: Contrato;
  @Prop({ default: () => [] }) readonly condicionesComerciales!: Array<CondicionComercial>;
  @Prop({ default: () => [] }) readonly condicionesDivisiones!: Array<CondicionDivision>;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  cargando = false;
  search = "";
  panelCondicion: number | null = null;
  panelDivision: number | null = null;
  /** Cambia tras cada alta para limpiar los formularios de "nueva". */
  claveNueva = 0;
  condicionEditando: CondicionComercial | null = null;
  divisionEditando: CondicionDivision | null = null;
  dialogoCondicion = false;
  dialogoDivision = false;
  dialogoEliminar = false;
  pendiente: Pendiente | null = null;
  snackbar = { model: false, texto: "", color: "success" };

  // --- datos del contrato ---
  get codigo(): number {
    return this.contrato.codigo || 0;
  }
  get clienteSnapshot(): Contrato["clienteSnapshot"] {
    return this.contrato?.clienteSnapshot || ({} as Contrato["clienteSnapshot"]);
  }
  get localSnapshot(): Contrato["localSnapshot"] {
    return this.contrato?.localSnapshot || ({} as Contrato["localSnapshot"]);
  }
  get superficieTotal(): number {
    return this.contrato.superficieTotal || this.localSnapshot.superficie || 0;
  }
  get fechaInicio(): string {
    return aFecha(this.contrato.fechaInicio)?.toLocaleDateString("es-CL") ?? "N/R";
  }
  get fechaFin(): string {
    return aFecha(this.contrato.fechaFin)?.toLocaleDateString("es-CL") ?? "N/R";
  }
  get dia_uf(): number {
    return this.contrato.dia_uf || 0;
  }
  get renovacion(): string {
    return this.contrato.renovacion || "N/R";
  }
  get centroCostoContrato(): string {
    return this.contrato.centroCostoContrato || this.localSnapshot.centroCosto || "N/R";
  }
  get estadoContrato(): string {
    return this.contrato.estadoContrato || "N/R";
  }

  // --- condiciones y divisiones de este contrato ---
  get items(): Array<CondicionComercial> {
    return this.condicionesComerciales
      .filter((c) => String(c.codigo_contrato) === String(this.codigo))
      .map((c) => ({ ...c }))
      .sort((a, b) => Number(a.codigo_condicion) - Number(b.codigo_condicion));
  }

  get itemsDivisiones(): Array<CondicionDivision> {
    return this.condicionesDivisiones
      .filter((d) => String(d.codigo_contrato) === String(this.codigo))
      .map((d) => ({ ...d }))
      .sort(
        (a, b) =>
          Number(a.codigo_condicion) - Number(b.codigo_condicion) ||
          Number(a.codigo_division) - Number(b.codigo_division)
      );
  }

  /** Mayor código de condición del contrato (el formulario propone el siguiente). */
  get codigoCondicionContrato(): number {
    return Math.max(0, ...this.items.map((c) => Number(c.codigo_condicion) || 0));
  }

  get textoEliminar(): string {
    const p = this.pendiente;
    if (!p) return "";
    if (p.tipo === "division") {
      return `¿ELIMINAR LA DIVISIÓN ${p.division.codigo_division} (${p.division.nombre_division})?`;
    }
    const extra = p.divisiones.length ? ` Y SUS ${p.divisiones.length} DIVISIONES` : "";
    return `¿ELIMINAR LA CONDICIÓN ${p.condicion.codigo_condicion}${extra}?`;
  }

  // --- guardar ---
  async guardarCondicion(data: DataFormularioCondicionComercial): Promise<void> {
    const esNueva = !data.doc.id;
    await this.guardar(() => this.setCondicionComercial(data.doc),
      esNueva ? "Condición creada" : "Condición actualizada");
    this.panelCondicion = null;
  }

  async guardarDivision(data: DataFormularioCondicionDivision): Promise<void> {
    const esNueva = !data.doc.id;
    await this.guardar(() => this.setCondicionDivision(data.doc),
      esNueva ? "División creada" : "División actualizada");
    this.panelDivision = null;
  }

  async guardar(accion: () => Promise<unknown>, exito: string): Promise<void> {
    this.cargando = true;
    try {
      await accion();
      this.avisar(exito);
      this.claveNueva++;
      this.cerrarEdicion();
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      this.avisar("No se pudo guardar. Intenta de nuevo.", "error");
    } finally {
      this.cargando = false;
    }
  }

  // --- editar ---
  editarCondicion(condicion: CondicionComercial): void {
    this.condicionEditando = condicion;
    this.dialogoCondicion = true;
  }

  editarDivision(division: CondicionDivision): void {
    this.divisionEditando = division;
    this.dialogoDivision = true;
  }

  cerrarEdicion(): void {
    this.dialogoCondicion = false;
    this.dialogoDivision = false;
    this.condicionEditando = null;
    this.divisionEditando = null;
  }

  // --- eliminar ---
  pedirEliminarCondicion(condicion: CondicionComercial): void {
    const divisiones = this.itemsDivisiones.filter(
      (d) => String(d.codigo_condicion) === String(condicion.codigo_condicion)
    );
    this.pendiente = { tipo: "condicion", condicion, divisiones };
    this.dialogoEliminar = true;
  }

  pedirEliminarDivision(division: CondicionDivision): void {
    this.pendiente = { tipo: "division", division };
    this.dialogoEliminar = true;
  }

  async confirmarEliminar(): Promise<void> {
    const p = this.pendiente;
    if (!p) return;
    this.cargando = true;
    try {
      if (p.tipo === "division") {
        if (p.division.id) await this.deleteCondicionDivision(p.division.id);
        this.avisar("División eliminada");
      } else {
        for (const d of p.divisiones) if (d.id) await this.deleteCondicionDivision(d.id);
        if (p.condicion.id) await this.deleteCondicionComercial(p.condicion.id);
        this.avisar("Condición eliminada");
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      this.avisar("No se pudo eliminar. Intenta de nuevo.", "error");
    } finally {
      this.cargando = false;
      this.cerrarEliminar();
    }
  }

  cerrarEliminar(): void {
    this.dialogoEliminar = false;
    this.pendiente = null;
  }

  avisar(texto: string, color = "success"): void {
    this.snackbar = { model: true, texto, color };
  }

  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
